import { BaseEvents } from '@/shared/utils';
import { ResetPasswordPayload } from './types';

export const ChangePasswordEventKeys = {
  changePassword: {
    update: 'changePassword/update',
  },
  redirect: {
    to: 'redirect/to',
  },
} as const;

export interface ChangePasswordEvents extends BaseEvents {
  'changePassword/update': ResetPasswordPayload;
  'redirect/to': string;
}
